import { usePaginatedQuery, useQuery, useMutation } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is a client library, not a backend module
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: Convex generated dataModel lives outside src/
import type { TChatSentiment } from '@/@types/retellChat';

// ---------------------------------------------------------------------------
// Chat Session History (paginated)
// ---------------------------------------------------------------------------

export function useChatSessionHistory(
  orgId: Id<'organisations'> | undefined,
  filters?: {
    sentiment?: TChatSentiment;
    success?: 'yes' | 'no';
    leadStatus?: 'has_lead' | 'no_lead';
    search?: string;
  }
) {
  const result = usePaginatedQuery(
    api.retellChat.queries.listByOrg,
    orgId !== undefined
      ? {
          orgId,
          sentiment: filters?.sentiment,
          success: filters?.success,
          leadStatus: filters?.leadStatus,
          search: filters?.search,
        }
      : 'skip',
    { initialNumItems: 25 }
  );

  return {
    results: result.results,
    isLoading: result.status === 'LoadingFirstPage',
    loadMore: result.loadMore,
    status: result.status,
  };
}

// ---------------------------------------------------------------------------
// Chat Session Detail
// ---------------------------------------------------------------------------

export function useChatSessionDetail(sessionId: Id<'retellChatSessions'> | undefined) {
  const data = useQuery(
    api.retellChat.queries.getById,
    sessionId !== undefined ? { sessionId } : 'skip'
  );
  return { data, isLoading: data === undefined };
}

// ---------------------------------------------------------------------------
// Create Lead From Chat
// ---------------------------------------------------------------------------

export function useCreateLeadFromChat() {
  return useMutation(api.retellChat.mutations.createLeadFromChat);
}
